import { InjectionToken } from '@angular/core';

export const FEATURE_FLAGS_TOKEN = new InjectionToken<{ [key: string]: boolean }>('featureFlags');
